//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        AQAvatar,
        AQButton
    },
    beforeRouteEnter(to, from, next) {
        next(vueInstance => {
            const vm = vueInstance;
            if (to.params && to.params.username) {
                vm.username = to.params.username;
            }
        });
    },
    data() {
        return {
            username: ""
        };
    },
    computed: {
        ...mapGetters("main", ["getShowAccessibilityOption"]),
        passChangedMsg() {
            return this.$t("login.passwordChangedMessage");
        }
    },
    methods: {
        redirectToLogin() {
            this.$router.push({ name: "login", params: { username: this.username, initialState: true } });
            this.$emit("resetPass");
        }
    }
};
